import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2e51786"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title" }, " User settings ", -1))
const _hoisted_2 = { class: "theme-selector-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Select a theme:", -1))
const _hoisted_4 = { class: "theme-menu" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Clear settings:", -1))
const _hoisted_7 = { class: "theme-menu" }

import { ref } from 'vue';
import { UserSettings } from '@/core/UserSettings';
import DefaultIcon from '@/components/atomic/DefaultIcon';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSettings',
  props: {
	workspace: Object
},
  setup(__props) {

const props = __props;



const us = new UserSettings();
const settings = ref(us.settings);
const theme = ref(us.settings.theme);
const themes = us.themes;
const themeNames = Object.keys(themes);

const setTheme = (newTheme: string) => {
	us.setAppTheme(newTheme);
	settings.value = us.settings;
	theme.value = us.settings.theme;
	const editors = props.workspace.editors;
	props.workspace.setAppTheme(newTheme);
	for (const e of editors) {
		props.workspace.setTheme(e.id, newTheme);
	}
	
};

const clearSettings = () => {
	window.localStorage.clear();
	window.sessionStorage.clear();
	document.location.reload();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themeNames), (t) => {
          return (_openBlock(), _createElementBlock("li", { key: t }, [
            _createElementVNode("button", {
              tabindex: "0",
              class: _normalizeClass({ active: t == theme.value }),
              onClick: ($event: any) => (setTheme(t))
            }, _toDisplayString(t ? t : 'default'), 11, _hoisted_5)
          ]))
        }), 128))
      ]),
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", null, [
          _createElementVNode("button", {
            tabindex: "0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (clearSettings()))
          }, [
            _createVNode(_unref(DefaultIcon), {
              class: "icon-action-delete",
              icon: "codicon-trash"
            }),
            _createTextVNode(" Delete session data")
          ])
        ])
      ])
    ])
  ], 64))
}
}

})